import { api } from '../index';
//import { objectToFormData } from '@/api/util';

const prefix = '/api/payment/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

// export function apiIndexForPayment(param) {
// 	return api.post(prefix + 'indexForPayment', param);
// }

export function apiSelectApList(param) {
	return api.post(prefix + 'selectApList', param);
}

export function apiSelectApHistory(param) {
	return api.post(prefix + 'selectApHistory', param);
}

// export function apiAddCart(param) {
// 	return api.post(prefix + 'addCart', param);
// }

// export function apiRemoveCart(param) {
// 	return api.post(prefix + 'removeCart', param);
// }

export function apiProcessPayment(param) {
	return api.post(prefix + 'processPayment', param);
}

export function apiSelectPaymentItemList(param) {
	return api.post(prefix + 'selectPaymentItemList', param);
}

export function apiSelectPaymentPOList(param) {
	return api.post(prefix + 'selectPaymentPOList', param);
}

export function apiSelectPaymentReverseList(param) {
	return api.post(prefix + 'selectPaymentReverseList', param);
}

export function apiReversePayment(param) {
	return api.post(prefix + 'reversePayment', param);
}

// export function apiUpdatePostCheckDate(param) {
// 	return api.post(prefix + 'updatePostCheckDate', param);
// }

// export function apiUpdatePostCheckValidity(param) {
// 	return api.post(prefix + 'updatePostCheckValidity', param);
// }

// export function apiUpdateCheckNo(param) {
// 	return api.post(prefix + 'updateCheckNo', param);
// }

// export function apiUpdateReceiptRemark(param) {
// 	return api.post(prefix + 'updateReceiptRemark', param);
// }

// export function apiBounceList(param) {
// 	return api.post(prefix + 'bounceList', param);
// }

// export function apiBounceDate(receipt_item_no, param) {
// 	return api.put(prefix + 'bounce-date/' + receipt_item_no, objectToFormData(param));
// }
